<template>
       <!-- Breadcrumb -->
    <div class="breadcrumb">
      <a href="/">Accueil</a> >
      <RouterLink to="/produits">Produits</RouterLink> >
      <RouterLink to="/equipementLabo">Equipements Labo</RouterLink>
    </div>
    <div class="filter-title">
        <h3>Filtrer par :</h3>
    </div>
  <div class="equipement-labo-container">
    <!-- Sidebar des filtres-->
    <div class="filter-sidebar">
      <!-- Filtrer par catégorie -->
      <div class="filter-section">
        <h4>Catégorie</h4>
        <ul>
          <li><input type="checkbox" value="Analyser" @change="toggleCategoryFilter" /> <label>Analyser</label></li>
          <li><input type="checkbox" value="Spectrophotomètres" @change="toggleCategoryFilter" /> <label>Spectrophotomètres</label></li>
          <li><input type="checkbox" value="Centrifugeuses" @change="toggleCategoryFilter" /> <label>Centrifugeuses</label></li>
        </ul>
      </div>

      <!-- Filtrer par fabricant -->
      <div class="filter-section">
        <h4>Fabricant</h4>
        <ul>
          <li><input type="checkbox" value="SupraCare" @change="toggleManufacturerFilter" /> <label>AKIRON NEO</label></li>
          <li><input type="checkbox" value="BioLab" @change="toggleManufacturerFilter" /> <label>BIOTIME</label></li>
          <li><input type="checkbox" value="MedTech" @change="toggleManufacturerFilter" /> <label>MACCURA</label></li>
        </ul>
      </div>
    </div>

  
    <div class="main-content">
      <!-- Toolbar avec mode d'affichage et pagination -->
      <div class="toolbar">
        <div class="display-mode">
          <button @click="setDisplayMode('grid')" :class="{ active: displayMode === 'grid' }">
            <i class="fas fa-th-large"></i>
          </button>
          <button @click="setDisplayMode('list')" :class="{ active: displayMode === 'list' }">
            <i class="fas fa-list"></i>
          </button>
        </div>

        <div class="pagination">
          <span>Page {{ currentPage }} / {{ totalPages }}</span>
          <button @click="prevPage" :disabled="currentPage === 1">Précédent</button>
          <button @click="nextPage" :disabled="currentPage === totalPages">Suivant</button>
        </div>
      </div>

      <!-- affichage en grille ou liste selon l'option sélectionnée -->
      <div :class="displayMode === 'grid' ? 'product-grid' : 'product-list'">
        <div v-for="product in filteredProducts" :key="product.id" class="product-card">
          <img :src="product.image" :alt="product.name" class="product-image" />
          <div class="product-info">
            <h3>{{ product.name }}</h3>
            <p>{{ product.description }}</p>
            <router-link :to="`/equipementLabo/${product.id}`" class="read-more-button">Lire la suite</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      displayMode: 'grid', // Modes possibles: 'grid' ou 'list'
      currentPage: 1,
      totalPages: 5, // Nombre total de pages
      selectedCategories: [], // Stocke les catégories sélectionnées
      selectedManufacturers: [], // Stocke les fabricants sélectionnés
      products: [
        {
          id: 1,
          name: 'IFA Analyer',
          category: 'Analyser',
          manufacturer: 'SupraCare',
          description: 'L’akiron® NEO est un analyseur IFA compact pour l’imagerie numérique automatisée des lames traitées afin de soutenir le diagnostic des maladies auto-immunes...',
          image: '/IFA-Analyser.png'
        },
        {
          id: 2,
          name: 'LINE Automation DotDiver2.0',
          category: 'Analyser',
          manufacturer: 'Generic Assays',
          description: 'DotDiver2.0 est un analyseur d’immunoblots de paillasse compact pour le traitement et l’évaluation automatisés des immunoblots LINE et Dot afin d’aider au diagnostic des maladies auto-immunes...',
          image: '/LINE-Automation-2.png',
        },

             {
          id: 3,
          name: 'Analyseur d’hématologie automatique F 580',
          category: 'Analyser hématologie',
          manufacturer: 'Generic Assays',
          description: 'L’analyseur automatique d’hématologie F580 adopte une technologie de base de pointe...',
          image: '/analyser-580.png',
        },
       

              {
          id: 4,
          name: 'Analyseur d’hématologie automatique F 560',
          category: 'Analyser hématologie',
          manufacturer: 'Generic Assays',
          description: 'Innovant et précis L’analyseur automatique d’hématologie F 560 combine la technologie de base avec un cadre compact. Des performances...',
          image: '/analyser-560.png',
        },
                      {
          id: 5,
          name: 'Analyseur HbA1c automatique HLC-100',
          category: 'Analyser hématologie',
          manufacturer: 'Generic Assays',
          description: 'L’analyseur HbA1c entièrement automatisé HLC-100 de Biotime fournit une solution rapide et fiable pour le diagnostic du diabète. Il utilise la technique analytique de chromatographie liquide à haute performance (HPLC)...',
          image: '/HLC-100.jpg',
        },

                            {
          id: 6,
          name: 'Hemonitor H1',
          category: 'Analyser',
          manufacturer: 'Generic Assays',
          description: 'Hemonitor H1 est un dispositif médical de diagnostic in vitro qui analyse quantitativement la concentration d’hémoglobine dans le sang capillaire ou veineux...',
          image: '/hemonitor H1.png',
        },

      ]
    };
  },
  computed: {
    filteredProducts() {
      // Filtrer les produits en fonction des catégories et fabricants sélectionnés
      return this.products.filter(product => {
        const matchesCategory = this.selectedCategories.length === 0 || this.selectedCategories.includes(product.category);
        const matchesManufacturer = this.selectedManufacturers.length === 0 || this.selectedManufacturers.includes(product.manufacturer);
        return matchesCategory && matchesManufacturer;
      });
    }
  },
  methods: {
    toggleCategoryFilter(event) {
      const value = event.target.value;
      if (event.target.checked) {
        this.selectedCategories.push(value);
      } else {
        this.selectedCategories = this.selectedCategories.filter(category => category !== value);
      }
    },
    toggleManufacturerFilter(event) {
      const value = event.target.value;
      if (event.target.checked) {
        this.selectedManufacturers.push(value);
      } else {
        this.selectedManufacturers = this.selectedManufacturers.filter(manufacturer => manufacturer !== value);
      }
    },
    setDisplayMode(mode) {
      this.displayMode = mode; // Changer le mode d'affichage
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
  }
};
</script>

<style scoped>
/* ===== STYLE CLAIR PAR DÉFAUT ===== */

.breadcrumb {
  font-size: 10px;
  color: #888;
  margin-top: 0px;
  padding: 10px 50px;
}

.breadcrumb a {
  color: #1c1c1d;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb a:hover {
  color: #0056b3;
}

/* Conteneur principal */
.equipement-labo-container {
  display: flex;
  padding: 0px 50px;
}

.filter-title {
  padding: 0px 50px;
}

/* Sidebar des filtres à gauche */
.filter-sidebar {
  width: 250px;
  padding: 0px;
  background-color: #fafafa;
  border-radius: 0px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  margin-right: 20px;
  border: 1px solid #ccc;
}

.filter-section {
  margin-bottom: 20px;
  padding: 30px;
}

.filter-section h4 {
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.filter-section ul {
  list-style: none;
  padding: 0;
}

.filter-section ul li {
  margin-bottom: 10px;
}

/* Contenu principal à droite */
.main-content {
  flex: 1;
}

/* Toolbar avec mode d'affichage et pagination */
.toolbar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.display-mode button {
  background-color: #ffffff;
  border: 1px solid #ddd;
  padding: 10px;
  margin-right: 10px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.display-mode button.active {
  background-color: #00998B;
  color: #fff;
}

/* Espacement entre icônes */
.display-mode i + i {
  margin-left: 20px;
}

.pagination span {
  margin-right: 20px;
}

.pagination button {
  background-color: #00998B;
  color: white;
  border: none;
  padding: 8px 15px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

/* Grille produits */
.product-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.product-list {
  display: block;
}

/* Carte produit */
.product-card {
  background-color: #fafafa;
  border-radius: 0px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease;
  padding: 20px;
  border: 1px solid #ccc;
}

.product-card:hover {
  transform: translateY(-5px);
}

.product-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  margin-bottom: 20px;
}

.product-info h3 {
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.product-info p {
  font-size: 0.9rem;
  color: #666;
}

/* Bouton lire plus */
.read-more-button {
  display: inline-block;
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #00998B;
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.read-more-button:hover {
  background-color: #007f72;
}

/* Responsive */
@media (max-width: 768px) {
  .product-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media (max-width: 500px) {
  .product-grid {
    grid-template-columns: repeat(1, 1fr);
  }

  .filter-sidebar {
    display: none;
  }

  .filter-title {
    display: none;
  }

  .display-mode button {
    display: none;
  }
}

/* ===== 🌙 MODE SOMBRE AUTOMATIQUE ===== */
@media (prefers-color-scheme: dark) {
  body, .equipement-labo-container {
    background-color: #0b0f14;
    color: #e6edf1;
  }

  .breadcrumb {
    color: #aaa;
  }

  .breadcrumb a {
    color: #73d8cf;
  }

  .breadcrumb a:hover {
    color: #00bfa5;
  }

  .filter-sidebar {
    background-color: #10151c;
    border-color: rgba(255, 255, 255, 0.08);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
  }

  .filter-section h4 {
    color: #73d8cf;
  }

  .display-mode button {
    background-color: #142231;
    border-color: rgba(255, 255, 255, 0.1);
    color: #e6edf1;
  }

  .display-mode button.active {
    background-color: #00998B;
    color: #fff;
  }

  .pagination button {
    background-color: #00998B;
  }

  .product-card {
    background-color: #10151c;
    border-color: rgba(255, 255, 255, 0.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.6);
  }

  .product-info h3 {
    color: #e6edf1;
  }

  .product-info p {
    color: #9ca3af;
  }

  .read-more-button {
    background-color: #00998B;
  }

  .read-more-button:hover {
    background-color: #00bfa5;
  }
}
</style>

